import { ReactLenis } from "lenis/react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { EditorialMarquee } from "../components/landing/EditorialMarquee";
import { Services } from "../components/landing/Services";
import { Manifesto } from "../components/landing/Manifesto";
import { Mixes } from "../components/landing/Mixes";
import { Gallery } from "../components/landing/Gallery";
import { Booking } from "../components/landing/Booking";

export function Landing() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <div className="App relative" data-testid="landing-page">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Services />
          <Manifesto />
          <Mixes />
          <Gallery />
          <Booking />
        </main>
      </div>
    </ReactLenis>
  );
}
